module.exports = __webpack_public_path__ + "media/images/default/pay_services/1-56355fdc0ad860add81e47e25c5c5191.jpg";